
<div
  v-if="isCurrentApp"
  class="webtool current-app"
  @mouseenter="onMouseEnter"
  @mouseleave="onMouseLeave"
>
  <div
    class="webtool-icon-container"
  >
    <img
      class="webtool-icon"
      :src="iconSrc"
      alt=""
    >
  </div>
  <div
    class="webtool-text-container"
  >
    <div>
      <p class="app-name">
        {{ appData.title }}
      </p>
      <p class="app-subtitle">
        {{ appData.subtitle }}
      </p>
    </div>
  </div>
  <div class="nav-selection-underline-static" />

  <!-- Info Icon + Progress Circle -->
  <info-progress-circle
    v-if="appData.showInfoIcon"
    :progress-offset="progressOffset"
    :background-color="headerBackgroundColor"
  />
  <app-info-card
    :visible="appData.popupVisible"
    :app-data="appData"
  />
</div>
<a
  v-else
  :href="appLink"
  :class="[
    'webtool notcurrentapp',
    { userdoesnthaveaccess: !appData.userAccess }
  ]"
  data-app-nav
  @click="onNonCurrentClick"
  @mouseenter="onMouseEnter"
  @mouseleave="onMouseLeave"
>
  <div
    class="webtool-icon-container"
    :style="{ opacity: appData.userAccess ? 1 : 0.4 }"
  >
    <img
      class="webtool-icon"
      :src="iconSrc"
      alt=""
    >
  </div>
  <div
    class="webtool-text-container"
    :style="{ opacity: appData.userAccess ? 1 : 0.4 }"
  >
    <div>
      <p class="app-name">
        {{ appData.title }}
      </p>
      <p class="app-subtitle">
        {{ appData.subtitle }}
      </p>
    </div>
  </div>
  <div class="nav-selection-underline" />

  <!-- Info Icon + Progress Circle -->
  <info-progress-circle
    v-if="appData.showInfoIcon"
    :progress-offset="progressOffset"
    :background-color="headerBackgroundColor"
  />
  <app-info-card
    :visible="appData.popupVisible"
    :app-data="appData"
  />
</a>
